import { api } from "./api";

export const addFolderApi = (params) => {
    return api.post(`/folder/create`, JSON.stringify(params));
};
export const folderListApi = (params) => {
    return api.get(`/folder/list`, { params });
};

export const folderEditApi = (params) => {
    return api.post(`/folder/edit`, JSON.stringify(params));
};

export const folderDeleteApi = (params) => {
    return api.post(`/folder/delete`, JSON.stringify(params));
};

export const folderViewApi = (params) => {
    return api.get(`/folder/view`, { params: params });
};